import { ref } from 'vue';

// Puente entre los ítems de "Editar / Eliminar para todos" (dentro del ContextMenu, que se desmonta al cerrarse) y sus
// diálogos (montados FUERA del v-if, en la instancia part="dialogs" del mismo mensaje). Un pedido a la vez:
// { action: 'edit' | 'revoke', conversationId, messageId } | null.
export const masifiWaActionRequest = ref(null);
